<template>
  <footer class="app-footer">
    <span><a :href="SETTING['productLink']">{{ SETTING['product'] }}</a> &copy; {{ currentYear }} {{ SETTING['system'] }}.</span>
    <span class="ml-auto">Powered by <a :href="SETTING['productLink']">{{ SETTING['product'] }}</a></span>
  </footer>
</template>
<script>
const moment = require('moment-timezone')
export default {
  name: 'c-footer',
  computed: {
    currentYear: function () {
      return moment().tz('Asia/Taipei').format('YYYY')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Footer.vue